export default __webpack_public_path__ + "static/media/cp_geo_bz.152abd8d.svg";